import { normalizeGeolocationResponse } from './normalizeGeolocation'

const GEOLOCATION_BASE =
  process.env.NODE_ENV === 'production'
    ? 'https://geolocation.alo.software'
    : 'https://geolocation.dev.alo.software'

// ?headers returns CloudFront viewer geo (state, city, etc.) for IP-based defaults.
const GEOLOCATION_URL = `${GEOLOCATION_BASE}?headers`

// Cache the lookup on `window` so it is shared across every caller on the page,
// even when the module is loaded by more than one bundle/runtime (e.g. the
// Sprockets and Webpacker app both render React on the homepage). This keeps the
// endpoint to a single request per page. The promise is kept even on failure
// (resolving to `{}`) so a failed request is not retried by every other caller,
// which would otherwise cause duplicate requests.
const CACHE_KEY = '__aloGeolocationPromise'

// Resolves to the parsed geolocation response, or `{}` on any failure. The
// try/catch also covers environments without a global `fetch` (e.g. jsdom in
// tests), where calling it would otherwise throw synchronously.
const fetchGeolocation = async () => {
  try {
    const response = await fetch(GEOLOCATION_URL)
    const data = await response.json()
    return normalizeGeolocationResponse(data)
  } catch (error) {
    console.error(error)
    return {}
  }
}

export const getGeolocation = () => {
  if (typeof window === 'undefined') {
    return Promise.resolve({})
  }

  if (!window[CACHE_KEY]) {
    window[CACHE_KEY] = fetchGeolocation()
  }

  return window[CACHE_KEY]
}

export default getGeolocation
